module.exports = __webpack_public_path__ + "img/eye-close.9b27330d.svg";